/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TipoAnimaleCreateDTO
 */
export interface TipoAnimaleCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof TipoAnimaleCreateDTO
     */
    codice: string;
    /**
     * 
     * @type {string}
     * @memberof TipoAnimaleCreateDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TipoAnimaleCreateDTO
     */
    idRazza?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TipoAnimaleCreateDTO
     */
    maschio?: boolean;
}

/**
 * Check if a given object implements the TipoAnimaleCreateDTO interface.
 */
export function instanceOfTipoAnimaleCreateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "codice" in value;

    return isInstance;
}

export function TipoAnimaleCreateDTOFromJSON(json: any): TipoAnimaleCreateDTO {
    return TipoAnimaleCreateDTOFromJSONTyped(json, false);
}

export function TipoAnimaleCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): TipoAnimaleCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'codice': json['codice'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'idRazza': !exists(json, 'idRazza') ? undefined : json['idRazza'],
        'maschio': !exists(json, 'maschio') ? undefined : json['maschio'],
    };
}

export function TipoAnimaleCreateDTOToJSON(value?: TipoAnimaleCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'codice': value.codice,
        'descrizione': value.descrizione,
        'idRazza': value.idRazza,
        'maschio': value.maschio,
    };
}

